export const NOTE_COLOR_OPTIONS = [
  { value: 'red', label: 'Kırmızı', hex: '#ff4d4f' },
  { value: 'blue', label: 'Mavi', hex: '#1677ff' },
  { value: 'green', label: 'Yeşil', hex: '#52c41a' },
  { value: 'orange', label: 'Turuncu', hex: '#fa8c16' },
  { value: 'purple', label: 'Mor', hex: '#722ed1' },
  { value: 'gray', label: 'Gri', hex: '#8c8c8c' },
];

export const noteColorHex = (value) => (NOTE_COLOR_OPTIONS.find((o) => o.value === value) || NOTE_COLOR_OPTIONS[0]).hex;
